<template>
    <FeaturesPageFeaturePanel icon="bw1studio" :title="$t('pages.features.studioCard.title')"
                              :desc="$t('pages.features.studioCard.desc')">
        <ul class="studioFeaturesList">
            <li v-for="(i,index) in $t('pages.features.studioCard.featuresList')"
                :key="index">{{i}}
            </li>
        </ul>
        <div class="gallery-container">
            <StudioScreenshotGallery/>
        </div>
    </FeaturesPageFeaturePanel>

</template>

<script>
    import FeaturesPageFeaturePanel from "./toolkit/FeaturesPageFeaturePanel";
    import StudioScreenshotGallery from "./toolkit/StudioScreenshotGallery"

    export default {
        name: "StudioFeature",
        components: {FeaturesPageFeaturePanel,StudioScreenshotGallery}
    }
</script>

<style scoped lang="scss">
    @import "../../../theme/theme";

    ul > li {
        font-size: 0.9em;
        margin-bottom: 0.5em;
        text-align:justify;
        margin-right: 1em;
    }
    .gallery-container {
        display: grid;
        justify-items: center;
        padding-right: 1rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
</style>